import type { MaintenanceType } from "@services/maintenance/types";
import { normalizeText } from "./format";

const MAINTENANCE_CATEGORY_PREFIX = "manuten";

export const isMaintenanceCategoryName = (name?: string | null): boolean =>
  normalizeText(name ?? undefined).startsWith(MAINTENANCE_CATEGORY_PREFIX);

export const resolveMaintenanceTypeFromSubcategory = (subcategoryName?: string | null): MaintenanceType => {
  const normalized = normalizeText(subcategoryName ?? undefined);

  if (normalized.includes("preventiva")) return "PREVENTIVE";
  if (normalized.includes("corretiva")) return "CORRECTIVE";
  if (normalized.includes("mensalidade") || normalized.includes("assinatura")) return "SUBSCRIPTION";
  return "SINGLE";
};
